import { FaCheck } from "react-icons/fa";
import "./CheckBox.css"

const CheckBox = ({value, onChange, text}) => {
    return (
        <div className="borderContainer" onClick={() => onChange(!value)}>
            <div className="checkBoxCheck">
                { value &&
                    <FaCheck className="h-4 w-4"/>
                }  
            </div>
            <div>
                {text}
            </div>
        </div>
    );
}

export default CheckBox;